export default "__VITE_ASSET__B_kS9Ugl__"